var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldGpsSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 12.749h-2.04c-.35 3.81-3.4 6.86-7.21 7.21v2.04c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.04c-.61-.05-1.21-.18-1.78-.37-.71-.24-.93-1.14-.4-1.67l2.81-2.81c.04.01.07.01.11.01 1.73 0 3.12-1.39 3.12-3.12 0-.04 0-.07-.01-.11l2.81-2.81c.53-.53 1.43-.31 1.67.4.19.57.32 1.16.37 1.78H22c.41-.01.75.33.75.74s-.34.75-.75.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.68 2.23-3.61 3.61c-1.2-.99-2.7-1.64-4.33-1.79V2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2.04c-3.81.36-6.86 3.4-7.21 7.21H2c-.41 0-.75.34-.75.75s.34.75.75.75h2.04c.15 1.63.8 3.13 1.79 4.33l-3.61 3.61c-.3.3-.3.79 0 1.09.16.14.35.22.55.22.2 0 .39-.08.54-.23L21.77 3.31c.31-.3.31-.78 0-1.08-.3-.3-.79-.3-1.09 0zM12 8.88c.58 0 1.12.17 1.58.45l-4.25 4.25c-.28-.46-.45-1-.45-1.58 0-1.72 1.4-3.12 3.12-3.12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldGpsSlash);
export default __webpack_public_path__ + "static/media/vuesax-bold-gps-slash.d7e786220de6f1bdebd8f41da866bebc.svg";
export { ForwardRef as ReactComponent };